import {defineMessages} from 'react-intl'

/**
 * Single catalog of sidebar labels, shared by both live sidebar variants
 * (`SidebarMenuMainNew` and `SidebarMenuMainLegacy` — see `SidebarMenuMain`,
 * which picks one based on the user's `sidebarView` preference). Keeping one
 * catalog means a label is translated once and both variants stay in sync.
 *
 * Namespace `MENU.*` was already created by the Metronic template
 * (`MENU.DASHBOARD`); this extends it.
 */
export const MENU_LABELS = defineMessages({
  // Section headers
  favorites: {id: 'MENU.section.favorites', defaultMessage: 'Favorites'},
  overview: {id: 'MENU.section.overview', defaultMessage: 'Overview'},
  crm: {id: 'MENU.section.crm', defaultMessage: 'CRM'},
  communication: {id: 'MENU.section.communication', defaultMessage: 'Communication'},
  operations: {id: 'MENU.section.operations', defaultMessage: 'Operations'},
  management: {id: 'MENU.section.management', defaultMessage: 'Management'},
  resources: {id: 'MENU.section.resources', defaultMessage: 'Resources'},

  // Entries
  academy: {id: 'MENU.item.academy', defaultMessage: 'Academy'},
  automations: {id: 'MENU.item.automations', defaultMessage: 'Automations'},
  billing: {id: 'MENU.item.billing', defaultMessage: 'Billing'},
  onboarding: {id: 'MENU.item.onboarding', defaultMessage: 'Onboarding'},
  calendar: {id: 'MENU.item.calendar', defaultMessage: 'Calendar'},
  campaigns: {id: 'MENU.item.campaigns', defaultMessage: 'Campaigns'},
  commissions: {id: 'MENU.item.commissions', defaultMessage: 'Commissions'},
  contacts: {id: 'MENU.item.contacts', defaultMessage: 'Contacts'},
  dashboardByCommissions: {
    id: 'MENU.item.dashboardByCommissions',
    defaultMessage: 'Dashboard based on commissions',
  },
  dashboardByStatus: {
    id: 'MENU.item.dashboardByStatus',
    defaultMessage: 'Dashboard based on status',
  },
  dashboards: {id: 'MENU.item.dashboards', defaultMessage: 'Dashboards'},
  digitalSignatures: {id: 'MENU.item.digitalSignatures', defaultMessage: 'Digital Signatures'},
  gmail: {id: 'MENU.item.gmail', defaultMessage: 'Gmail'},
  inbox: {id: 'MENU.item.inbox', defaultMessage: 'Inbox'},
  integrations: {id: 'MENU.item.integrations', defaultMessage: 'Integrations'},
  leads: {id: 'MENU.item.leads', defaultMessage: 'Leads'},
  mediaManager: {id: 'MENU.item.mediaManager', defaultMessage: 'Media Manager'},
  medicareCenter: {id: 'MENU.item.medicareCenter', defaultMessage: 'Medicare Center'},
  myCalls: {id: 'MENU.item.myCalls', defaultMessage: 'My calls'},
  notifications: {id: 'MENU.item.notifications', defaultMessage: 'Notifications'},
  pdfSigning: {id: 'MENU.item.pdfSigning', defaultMessage: 'PDF Signing'},
  policies: {id: 'MENU.item.policies', defaultMessage: 'Policies'},
  policyChat: {id: 'MENU.item.policyChat', defaultMessage: 'PolicyChat'},
  quotes: {id: 'MENU.item.quotes', defaultMessage: 'Quotes'},
  recipients: {id: 'MENU.item.recipients', defaultMessage: 'Recipients'},
  resourceCenter: {id: 'MENU.item.resourceCenter', defaultMessage: 'Resource Center'},
  signatureForms: {id: 'MENU.item.signatureForms', defaultMessage: 'Signature Forms'},
  tasks: {id: 'MENU.item.tasks', defaultMessage: 'Tasks'},
  templates: {id: 'MENU.item.templates', defaultMessage: 'Templates'},
  tickets: {id: 'MENU.item.tickets', defaultMessage: 'Tickets'},
  users: {id: 'MENU.item.users', defaultMessage: 'Users'},

  // Favorites star toggle
  addToFavorites: {id: 'MENU.favorites.add', defaultMessage: 'Add to favorites'},
  removeFromFavorites: {id: 'MENU.favorites.remove', defaultMessage: 'Remove from favorites'},
})
